import { render, staticRenderFns } from "./workFlowSyncManagement.vue?vue&type=template&id=923399a2&"
import script from "./workFlowSyncManagement.vue?vue&type=script&lang=js&"
export * from "./workFlowSyncManagement.vue?vue&type=script&lang=js&"
import style0 from "./workFlowSyncManagement.vue?vue&type=style&index=0&id=923399a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports